import { TypedDocumentNode, gql } from '@apollo/client'

import { DrugName } from './types'

export const DRUG_NAME_FRAGMENT: TypedDocumentNode<
  DrugName,
  Record<string, never>
> = gql`
  fragment drugName on ExtendedFlatDrug {
    name
    type: medicalType
  }
`
